import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { TextFormat } from 'react-jhipster';
import { Link, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './callback.reducer';

export const CallbackDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id!));
  }, []);

  const callbackEntity = useAppSelector(state => state.callback.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="callbackDetailsHeading">Callback</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{callbackEntity.id}</dd>
          <dt>
            <span id="celularCliente">Celular Cliente</span>
          </dt>
          <dd>{callbackEntity.celularCliente}</dd>
          <dt>
            <span id="certBdeM">Cert Bde M</span>
          </dt>
          <dd>{callbackEntity.certBdeM}</dd>
          <dt>
            <span id="certComercioProveedor">Cert Comercio Proveedor</span>
          </dt>
          <dd>{callbackEntity.certComercioProveedor}</dd>
          <dt>
            <span id="claveInstitucionCliente">Clave Institucion Cliente</span>
          </dt>
          <dd>{callbackEntity.claveInstitucionCliente}</dd>
          <dt>
            <span id="claveRastreo">Clave Rastreo</span>
          </dt>
          <dd>{callbackEntity.claveRastreo}</dd>
          <dt>
            <span id="concepto">Concepto</span>
          </dt>
          <dd>{callbackEntity.concepto}</dd>
          <dt>
            <span id="digitoVerificadorCliente">Digito Verificador Cliente</span>
          </dt>
          <dd>{callbackEntity.digitoVerificadorCliente}</dd>
          <dt>
            <span id="horaEnvioMensaje">Hora Envio Mensaje</span>
          </dt>
          <dd>
            {callbackEntity.horaEnvioMensaje ? (
              <TextFormat value={callbackEntity.horaEnvioMensaje} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="horaProcMensajeCobro">Hora Proc Mensaje Cobro</span>
          </dt>
          <dd>
            {callbackEntity.horaProcMensajeCobro ? (
              <TextFormat value={callbackEntity.horaProcMensajeCobro} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="horaSolicitudMensajeCobro">Hora Solicitud Mensaje Cobro</span>
          </dt>
          <dd>
            {callbackEntity.horaSolicitudMensajeCobro ? (
              <TextFormat value={callbackEntity.horaSolicitudMensajeCobro} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="idMensajeCobro">Id Mensaje Cobro</span>
          </dt>
          <dd>{callbackEntity.idMensajeCobro}</dd>
          <dt>
            <span id="monto">Monto</span>
          </dt>
          <dd>{callbackEntity.monto}</dd>
          <dt>
            <span id="nombreCliente">Nombre Cliente</span>
          </dt>
          <dd>{callbackEntity.nombreCliente}</dd>
          <dt>
            <span id="numeroCuentaCliente">Numero Cuenta Cliente</span>
          </dt>
          <dd>{callbackEntity.numeroCuentaCliente}</dd>
          <dt>
            <span id="resultadoMensajeCobro">Resultado Mensaje Cobro</span>
          </dt>
          <dd>{callbackEntity.resultadoMensajeCobro}</dd>
          <dt>
            <span id="tipoCuentaCliente">Tipo Cuenta Cliente</span>
          </dt>
          <dd>{callbackEntity.tipoCuentaCliente}</dd>
          <dt>
            <span id="selloDigital">Sello Digital</span>
          </dt>
          <dd>{callbackEntity.selloDigital}</dd>
          <dt>
            <span id="timestampRecibido">Timestamp Recibido</span>
          </dt>
          <dd>
            {callbackEntity.timestampRecibido ? (
              <TextFormat value={callbackEntity.timestampRecibido} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="extra1">Extra 1</span>
          </dt>
          <dd>{callbackEntity.extra1}</dd>
          <dt>
            <span id="extra2">Extra 2</span>
          </dt>
          <dd>{callbackEntity.extra2}</dd>
          <dt>
            <span id="extra3">Extra 3</span>
          </dt>
          <dd>{callbackEntity.extra3}</dd>
          <dt>
            <span id="extra4">Extra 4</span>
          </dt>
          <dd>{callbackEntity.extra4}</dd>
          <dt>
            <span id="extra5">Extra 5</span>
          </dt>
          <dd>{callbackEntity.extra5}</dd>
          <dt>
            <span id="extra6">Extra 6</span>
          </dt>
          <dd>{callbackEntity.extra6}</dd>
          <dt>
            <span id="extra7">Extra 7</span>
          </dt>
          <dd>{callbackEntity.extra7}</dd>
          <dt>
            <span id="extra8">Extra 8</span>
          </dt>
          <dd>{callbackEntity.extra8}</dd>
          <dt>
            <span id="extra9">Extra 9</span>
          </dt>
          <dd>{callbackEntity.extra9}</dd>
          <dt>
            <span id="extra10">Extra 10</span>
          </dt>
          <dd>{callbackEntity.extra10}</dd>
          <dt>
            <span id="createdDate">Created Date</span>
          </dt>
          <dd>
            {callbackEntity.createdDate ? <TextFormat value={callbackEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
        </dl>
        <Button as={Link as any} to="/callback" replace variant="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button as={Link as any} to={`/callback/${callbackEntity.id}/edit`} replace variant="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default CallbackDetail;
